import styled from 'styled-components'

export const PageNotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`
export const PageNotFoundLogo = styled.img`
  max-width: 8.35rem;
  z-index: 2;
`
export const PageNotFoundLogoContainer = styled.div`
  margin-left: 60px;
  padding-top: 30px;
`
export const PageNotFoundContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const PageNotFoundTitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const PageNotFoundTitlePrimary = styled.h1`
  margin: 0;
  font-family: 'Poppins';
  font-size: 200px;
  color: ${({ theme }) => theme.colors.primary};
`

export const PageNotFoundTitleSecondary = styled.h1`
  margin: 0;
  font-family: 'Poppins';
  font-size: 200px;
  color: #00e3d6;
`
export const PageNotFoundDescription = styled.p`
  margin: 0;
  font-family: 'Work Sans';
  font-size: 36px;
  color: ${({ theme }) => theme.colors.fontSecondary};
  text-align: center;
`
